<div class="login-container">
    <!--     <div class="text-holder" (keyup.enter)="!isLoading && email && password ? login() : false">

        <h2>Welcome Back!</h2>
        <h3 style="margin-bottom:30px">Log in to continue</h3>
        <span *ngIf="errortext" style="color:red;font-size:12px"><i class="fas fa-exclamation-circle"></i> {{errortext}}</span>
        <label>email address</label>
        <input #focusthis [(ngModel)]="email" type="email" placeholder="Enter email" autofocus>
        <label>password</label>
        <input (keyup.enter)="login()" [(ngModel)]="password" type="password" placeholder="Enter password">

        <button (click)="login()" [disabled]="isLoading || !email || !password ">
            <ng-container *ngIf="!isLoading">Login</ng-container>
            <img *ngIf="isLoading" class="spin" src="../../../assets/img/loading.svg" style="width:20px">
        </button>
        <div class="flex left-right">
            <a [routerLink]="['/']" routerLinkActive="router-link-active">Back</a>
            <a [routerLink]="['/auth/register']" routerLinkActive="router-link-active" style="float:right">Create a new account</a>
        </div>

    </div> -->

    <div class="text-holder">
        <h2>Welcome Back!</h2>
        <h3 style="margin-bottom:30px">{{'Log in to continue as admin:' | translate}}</h3>
        <button (click)="loginWithBrowser()" [disabled]="isLoading">
            <ng-container>Login</ng-container>
        </button>
    </div>
    <div class="text-holder">
        <h3 style="margin-top:50px; color: var(--pink);">{{ 'Not an admin? Please go directly to the URL of your organisation to use the booking system.' | translate}}</h3>
        <div *ngIf="lastOrganisationUrl" style="margin-top: 20px;">
            <p style="margin: 10px 0; font-size: 14px;">{{ 'Your last used booking system:' | translate}}</p>
            <a [href]="lastOrganisationUrl" style="display: inline-block; padding: 10px 15px; background-color: var(--pink); color: white; text-decoration: none; border-radius: 4px; cursor: pointer;">
                {{ lastOrganisationUrl }}
            </a>
        </div>
    </div>
</div>

<div class="hero-bg"></div>
